import { IconButton } from "@carbon6/c6-frontend-design";
import type { MappingReviewItem } from "../../../feature/mappingReview";
import styles from "./MappingPanel.module.css";

export function MappingReviewList({
  items,
  onSelect,
}: {
  items: readonly MappingReviewItem[];
  onSelect: (item: MappingReviewItem) => void;
}) {
  return (
    <section className={styles.review} aria-label="확인 필요 항목">
      <strong>확인 필요 항목 {items.length}</strong>
      {items.length === 0 ? (
        <p>영상과 핸드의 방향을 비교하고 샘플 검증으로 매핑을 확인해 주세요.</p>
      ) : (
        <ul>
          {items.map((item) => (
            <li key={item.id}>
              <IconButton
                text={item.label}
                variant="surface"
                size="sm"
                onClick={() => onSelect(item)}
              />
              <span>{item.detail}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
